import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { checkForOverride } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";
import * as cuesApi from '../../../api/cue'
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function Credits({
	cue,
	cloud = false,
	baseTheme,
	baseThemeId,
}) {
	const { projectId } = useParams()
	const [hasBeenSeen, setHasBeenSeen] = useState(false);

	const dataSources = useSelector((state) => state.main?.dataSources) || {};

	const creditsRef = useRef();

	const lastDivRef = useRef(null);

  useEffect(() => {
			const observer = new IntersectionObserver(

				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							setHasBeenSeen(true); // Mark as seen when it enters the viewport
						} else if (hasBeenSeen && cue.hideOnEnd) {
							return cuesApi.updateCue(cue.id, projectId, { status: 'going' })
						}
					});
				},
				{ threshold: 0 }
			);
	
			if (lastDivRef.current) {
				observer.observe(lastDivRef.current);
			}

    return () => {
      if (lastDivRef.current) {
        observer.unobserve(lastDivRef.current);
      }
    };
  }, [hasBeenSeen, cue.hideOnEnd, cue.id, projectId]);

	return (
		<div
			ref={creditsRef}
			className={`credits-holder ${
				cue.status === "onair" && "credits-animate"
			}`}
			style={{
				animationDuration: `${cue.speed || "10"}s`,
				transform: `translateY(${window.innerHeight}px)`,
			}}
		>
			<span
				style={{
					fontFamily: baseTheme.h2?.font || baseTheme.font?.family,
					color: checkForOverride(
						baseTheme,
						"message",
						cue.preset,
						"h2",
						"colour"
					),
					fontWeight:
						checkForOverride(baseTheme, "message", cue.preset, "h2", "bold") ===
						true
							? "bold"
							: "normal",
					fontStyle:
						checkForOverride(
							baseTheme,
							"message",
							cue.preset,
							"h2",
							"italic"
						) === true
							? "italic"
							: "normal",
					textDecoration:
						checkForOverride(
							baseTheme,
							"message",
							cue.preset,
							"h2",
							"underline"
						) === true
							? "underline"
							: "none",
				}}
				className={`whitespace-pre ${baseThemeId}_${
					cue.type
				}_small_text small_text 
					text-${checkForOverride(baseTheme, "message", cue.preset, "h2", "size")}
					leading-${checkForOverride(baseTheme, "message", cue.preset, "h2", "leading")}
					
                    `}
			>
				<ReplaceWithDataSource text={cue.lead} styled={true} />
			</span>
			<br />
			<span
				style={{
					fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
					color: checkForOverride(
						baseTheme,
						"message",
						cue.preset,
						"h1",
						"colour"
					),
					fontWeight:
						checkForOverride(baseTheme, "message", cue.preset, "h1", "bold") ===
						true
							? "bold"
							: "normal",
					fontStyle:
						checkForOverride(
							baseTheme,
							"message",
							cue.preset,
							"h1",
							"italic"
						) === true
							? "italic"
							: "normal",
					textDecoration:
						checkForOverride(
							baseTheme,
							"message",
							cue.preset,
							"h1",
							"underline"
						) === true
							? "underline"
							: "none",
				}}
				className={`whitespace-pre ${baseThemeId}_${
					cue.type
				}_large_text large_text 
					mt-s3 block
					text-${checkForOverride(baseTheme, "message", cue.preset, "h1", "size")}
					leading-${checkForOverride(baseTheme, "message", cue.preset, "h1", "leading")}
                    `}
			>
				<ReplaceWithDataSource text={cue.body} styled={true} />
			</span>
			<div
				className="mt-s10 grid max-w-7xl mx-auto"
				style={{ gridTemplateColumns: `repeat(${
					baseTheme?.["credits"]?.["crowd_size"] || 20}, minmax(0, 1fr))` }}
			>
				{dataSources[cue?.crowdDataSource] &&
					Object.entries(dataSources[cue?.crowdDataSource]?.crowd || {}).map(
						([index, author]) => {
							console.log('crowd', author)
							return (
								<img
									key={index}
									className="px-1 py-1 mx-auto block w-s2 rounded-full"
									src={author.profileImageUrl}
									alt=""
								/>
							);
						}
					)}
					<div ref={lastDivRef} className="bg-transparent mt-s5 text-transparent">END</div>
			</div>
		</div>
	);
}
